export default {
  navigationBarTitleText: '选择身份'
};
